export const ORDER_SEND_FORMAT_VALUES = ['pdf', 'peppol'] as const;
export const RECEPTION_FORMAT_VALUES = ['csv', 'edifact', 'nessuno'] as const;
export const CSV_FORMAT_VALUES = ['standard', 'custom'] as const;

export type OrderSendFormatValue = typeof ORDER_SEND_FORMAT_VALUES[number];
export type ReceptionFormatValue = typeof RECEPTION_FORMAT_VALUES[number];
export type CsvFormatValue = typeof CSV_FORMAT_VALUES[number];

export const DEFAULT_ORDER_SEND_FORMAT: OrderSendFormatValue = 'pdf';
export const DEFAULT_RECEPTION_FORMAT: ReceptionFormatValue = 'nessuno';
export const DEFAULT_CSV_FORMAT: CsvFormatValue = 'standard';

export const CSV_INTERNAL_FIELDS = [
  'order_ref',
  'bolla_ref',
  'shipment_date',
  'product_code',
  'quantity',
  'description',
  'lot',
  'expiry_date',
  'line_index'
] as const;

export type CsvInternalField = typeof CSV_INTERNAL_FIELDS[number];

export const CSV_REQUIRED_FIELDS: CsvInternalField[] = [
  'order_ref',
  'bolla_ref',
  'quantity',
  'shipment_date',
  'expiry_date',
  'lot',
  'product_code'
];

export const DEFAULT_CSV_DELIMITER = ';';

export const DEFAULT_CSV_DATE_FORMATS = ['YYYY-MM-DD', 'dd/mm/yyyy'];

export const DEFAULT_CSV_MAPPING_COLUMNS: Record<string, CsvInternalField> = {
  OrdineCliente: 'order_ref',
  NumeroDDT: 'bolla_ref',
  DataDDT: 'shipment_date',
  CodiceProdotto: 'product_code',
  QtaTotale: 'quantity',
  DescrizioneProdotto: 'description',
  ProgressivoRiga: 'line_index',
  Lotto: 'lot',
  DataScadenza: 'expiry_date'
};
/** Map API value (incl. legacy pdf) to form option. */
export function toFormReceptionFormat(apiValue: string | undefined): ReceptionFormatValue {
  if (!apiValue || apiValue === 'pdf') {
    return DEFAULT_RECEPTION_FORMAT;
  }
  if (apiValue === 'csv' || apiValue === 'edifact' || apiValue === 'nessuno') {
    return apiValue;
  }
  return DEFAULT_RECEPTION_FORMAT;
}
